/**
 * The PC-blocker alpha ramp, GENERATED from the 2014 tree by
 * tools/gen_pcblocker_ramp.py. Do not hand-edit.
 *
 * `d:/ymir Work/special/PCBlockerAlpha.dds` (`GameLib/MapOutdoor.cpp:73`) is
 * the alpha a building standing between the camera and the player is re-drawn
 * with. `MapOutdoorRender.cpp:628-631` takes colour from the pass below and
 * alpha from this texture alone, which is why only the alpha channel is here.
 */

/** The ramp is square; this is that side, in texels. */
export const PC_BLOCKER_RAMP_SIZE = 16;

/** One byte per texel, row-major from the top-left, base64-encoded. */
export const PC_BLOCKER_RAMP_ALPHA_BASE64 =
  "///////////////////////////u3buqqrvM7v/////////du5mZmZmZmard///////dqpmZiIiIiIiZmd3////uu5mIiHd3d3d3iIiq7v//3ZmZiHd3ZmZmd3eImcz//7uZiHd3ZmZVZmZ3d4iq//+qmYh3ZmZVVVVmZneImf//qpmId2ZVVURVVWZ3iJn//7uZiHdmZlVVVWZmd4iq///MmYh3d2ZmVWZmd3eIzP//7qqZiHd3ZmZmd3eIqu7////dmYiId3d3d3eImd3//////92qmYiIiIiIqt3/////////7syqmZmqzO7//////////////////////////w==";

/** The same bytes, decoded once, ready for `texImage2D` as a single-channel
 *  texture. */
export function pcBlockerRampAlpha(): Uint8Array {
  const binary = atob(PC_BLOCKER_RAMP_ALPHA_BASE64);
  const out = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) out[i] = binary.charCodeAt(i);
  return out;
}
